import React, { useEffect, useRef } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';

const HtmlEditor = ({ initialHtml, initialCss, onSave, width, height }) => {
  const editorRef = useRef(null);
  const editorInstance = useRef(null);

  useEffect(() => {
    if (!editorInstance.current) {
      const editor = grapesjs.init({
        container: editorRef.current,
        fromElement: false,
        height: '100vh',
        width: 'auto',
        deviceManager: {
          devices: [
            { name: 'Ticket', width: `${width}mm`, height: `${height}mm`, widthMedia: '' },
          ]
        },
        storageManager: false,
        // <-- Aquí le decimos dónde poner los bloques
        blockManager: {
          appendTo: '.blocks-panel',
          blocks: [
            { id: 'h1', label: 'Title', content: '<h1>Title</h1>' },
            { id: 'text', label: 'Text', content: '<p>Insert text here</p>' },
            { id: 'image', label: 'Image', content: '<img src="https://via.placeholder.com/150" />' },

            // Bloques personalizados para ticket
            {
              id: 'ticket-producto',
              label: 'Producto',
              category: 'Ticket',
              content: '<h4 class="producto">##PRODUCTO##</h4>'
            },
            {
              id: 'ticket-cliente',
              label: 'Nombre Cliente',
              category: 'Ticket',
              content: '<p class="cliente">##CLIENTE##</p>'
            },
            {
              id: 'ticket-dni',
              label: 'DNI',
              category: 'Ticket',
              content: '<p class="dni">##DNI##</p>'
            },
            {
              id: 'ticket-telefono',
              label: 'Telefono',
              category: 'Ticket',
              content: '<p class="telefono">##TELEFONO##</p>'
            },
            {
              id: 'ticket-localidad',
              label: 'Localidad',
              category: 'Ticket',
              content: '<p class="localidad">##LOCALIDAD##</p>'
            },
            {
              id: 'ticket-qr',
              label: 'QR',
              category: 'Ticket',
              content: '<img src="##QR##" style="width:180px" />'
            },
            {
              id: 'ticket-asiento',
              label: 'Asiento',
              category: 'Ticket',
              content: '<p class="asiento">Asiento: ##SEAT##</p>'
            },
            {
              id: 'ticket-numero',
              label: 'Numero',
              category: 'Ticket',
              content: '<p class="numero">##NUMERO##</p>'
            },
            {
              id: 'ticket-vendedor',
              label: 'Vendedor',
              category: 'Ticket',
              content: '<p class="vendedor">##VENDEDOR##</p>'
            },
          ]
        },

        // Style manager básico (opcional)
        styleManager: {
          sectors: [
            {
              name: 'Text',
              open: true,
              buildProps: ['font-family', 'font-size', 'color', 'line-height', 'text-align']
            },
            {
              name: 'Box',
              open: true,
              buildProps: ['width', 'height', 'margin', 'padding']
            }
          ]
        },
      });

      editor.on('load', () => {
        const css = `
          .rotate {
            white-space: nowrap !important;
            transform: rotate(-90deg);
            transform-origin: left top
            display: inline-block !important;
          }
        `;
        editor.addStyle(css);
      });

      editor.on('load', () => {
        const frame = editor.Canvas.getFrameEl(); // el iframe del canvas
        const body = frame.contentDocument.body;
        
        // Asegurar que el body del iframe pueda scrollear
        body.style.overflow = 'auto';
        body.style.minHeight = '100%';
      })

      editor.on('component:add', (model) => {
        model.setStyle({ position: 'absolute' });
        model.set({ draggable: true, resizable: true });
      });
      // Carga el HTML inicial si existe
      if (initialHtml) {
        editor.setComponents(initialHtml);
      }
      if (initialCss) {
        editor.setStyle(initialCss);
      }

      editorInstance.current = editor;
    }

    return () => {
      // cleanup al desmontar
      if (editorInstance.current) {
        editorInstance.current.destroy();
        editorInstance.current = null;
      }
    };
  }, [initialHtml, initialCss, width, height]);

  const handleSave = () => {
    if (editorInstance.current) {
      const html = editorInstance.current.getHtml();
      const css = editorInstance.current.getCss();
      onSave({ html, css });
    }
  };

  // Estilos rápidos para que se vea bien
  const leftStyle = {
    width: 260,
    borderRight: '1px solid #ddd',
    padding: 10,
    boxSizing: 'border-box'
  };
  const canvasStyle = { flex: 1, position: 'relative' };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      {/* Panel izquierdo donde GrapesJS añadirá la .gjs-blocks */}
      <div className="blocks-panel" style={leftStyle}>
      </div>

      {/* Lienzo GrapesJS */}
      <div style={canvasStyle}>
        <button
          onClick={handleSave}
          style={{ position: 'absolute', top: 10, right: 400, zIndex: 9999 }}
        >
          Guardar
        </button>
        <div ref={editorRef} style={{ height: '100%', boxSizing: 'border-box' }} />
      </div>
    </div>
  );
};

export default HtmlEditor;
